import React from "react";
import "./LegalPage.css";

export default function TrustSafety() {
  return (
    <div className="legal-container">
      <div className="legal-card">
        <h1 className="legal-title">Trust &amp; Safety</h1>

        <div className="legal-section">
          <p>
            ActivityBuddy exists so people can meet up around shared interests in a safe, respectful, and transparent way.
            These guidelines explain how we protect both hosts and customers throughout every request.
          </p>
        </div>

        <div className="legal-section">
          <h3>Verified bookings</h3>
          <ul className="legal-list">
            <li>Every booking request includes the customer's email and verified payment method.</li>
            <li>Hosts receive the full name tied to the customer’s booking request.</li>
            <li>We proactively monitor bookings for terms and policy violations.</li>
          </ul>
        </div>

        <div className="legal-section">
          <h3>Secure payments</h3>
          <ul className="legal-list">
            <li>All payments are processed through Stripe, we never store card numbers or bank details.</li>
            <li>Customers are only charged once the host accepts their request.</li>
            <li>If a request expires or is declined, the temporary authorization is released back to the customer.</li>
            <li>Payouts go directly to the host’s connected Stripe account after the activity.</li>
          </ul>
        </div>

        <div className="legal-section">
          <h3>Safety and conduct</h3>
          <ul className="legal-list">
            <li>We strongly recommend meeting in public, well-lit locations.</li>
            <li>Harassment, violence, hate speech, stalking, or unsafe behavior is not tolerated.</li>
            <li>Illegal activities, sexual services, or anything harmful are strictly prohibited.</li>
            <li>If something doesn’t feel right, hosts and customers can contact us at any time.</li>
          </ul>
        </div>

        <div className="legal-section">
          <h3>Reviews and transparency</h3>
          <p>
            After each activity, both hosts and customers can leave a private review about their experience.
            These reviews help us understand what’s working, identify issues early, and maintain a safe,
            high-quality community. In the future, we plan to publish reviews so everyone can make informed decisions with more transparency.
          </p>
        </div>

        <div className="legal-section">
          <h3>How we help protect the community</h3>
          <ul className="legal-list">
            <li>We review every host application before a page goes live.</li>
            <li>We monitor for fraud, abuse, and policy violations.</li>
            <li>We take action quickly when someone reports unsafe or inappropriate behavior.</li>
          </ul>
        </div>

        <div className="legal-section">
          <h3>Reporting an issue</h3>
          <p>
            If something feels off or violates these guidelines, email us at{" "}
            <a className="legal-link" href="mailto:support@activitybuddy.com">
              support@activitybuddy.com
            </a>
            . We review all reports and take them seriously.
          </p>
        </div>

        <div className="legal-section">
          <p>
            ActivityBuddy is a community built on trust, presence, and good experiences. We plan to continue improving safety features to keep the platform healthy for everyone.
          </p>
        </div>
      </div>
    </div>
  );
}